import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";

const initialState = {
    enquiryMaster: {
        addedEnquiries: [],
        allocatedVisitedEnquiries: [],
        allocatedUnvisitedEnquiries: [],
    },
};

let URL = endpoints.enquiryMaster;

const mapEnquiryItem = (obj, index) => {
    return {
        index: index + 1,
        id: obj.id !== null ? obj.id : "",
        addedDate: obj.addedDate !== null ? obj.addedDate : "",
        enquiryAllocatedId: obj.enquiryAllocatedId !== null ? obj.enquiryAllocatedId : "",
        enquiryAllocatedName: obj.enquiryAllocatedName !== null ? obj.enquiryAllocatedName : "",
        enquiryRaisedPlatform: obj.enquiryRaisedPlatform !== null ? obj.enquiryRaisedPlatform : "",
        enquiryRaisedPlatformName: obj.enquiryRaisedPlatformName !== null ? obj.enquiryRaisedPlatformName : "",
        potentialRate: obj.potentialRate !== null ? (obj.potentialRate == 0 ? 100 : obj.potentialRate) : 0,
        potentialRateValue: obj.potentialRateValue !== null ? obj.potentialRateValue : "",
        firmName: obj.firmName !== null ? obj.firmName : "",
        outletUniqueCode: obj.outletUniqueCode !== null ? obj.outletUniqueCode : "",
        beatId: obj.beatId !== null ? obj.beatId : "",
        beatName: obj.beatName !== null ? obj.beatName : "",
        ownerName: obj.ownerName !== null ? obj.ownerName : "",
        outletTypeName: obj.outletTypeName !== null ? obj.outletTypeName : "",
        townName: obj.townName !== null ? obj.townName : "",
        channelName: obj.channelName !== null ? obj.channelName : "",
        subChannelName: obj.subChannelName !== null ? obj.subChannelName : "",
        distributorId: obj.distributorId !== null ? obj.distributorId : "",
        distributorName: obj.distributorName !== null ? obj.distributorName : "",
        mobileNumber: obj.mobileNumber !== null ? obj.mobileNumber : "",
        address: obj.address !== null ? obj.address : "",
        latitude: obj.latitude !== null ? obj.latitude : "",
        longitude: obj.longitude !== null ? obj.longitude : "",
        isConverted: obj.isConverted !== null ? obj.isConverted : 0,
        isConvertedValue: obj.isConvertedValue !== null ? obj.isConvertedValue : "",
        isActive: obj.isActive !== null ? obj.isActive : 0,
        isActiveValue: obj.isActiveValue !== null ? obj.isActiveValue : "",
        isVisit: obj.isVisit !== null ? obj.isVisit : 0,
        isVisitValue: obj.isVisitValue !== null ? obj.isVisitValue : "",
        isSelfAllocated: obj.isSelfAllocated !== null ? obj.isSelfAllocated : 0,
    };
};

const mapEnquiryList = (list) => {
    return list ? list.map((obj, index) => mapEnquiryItem(obj, index)) : [];
};

const enquiryMasterSlice = createSlice({
    name: "enquiryMaster",
    initialState,
    reducers: {
        enquiryMasterSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                enquiryMaster: row,
            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const { enquiryMasterSuccess, resetState } = enquiryMasterSlice.actions;

export default enquiryMasterSlice.reducer;

export const getEnquiryMasterDataByDateAndStatus = ({ fromDate, toDate, status }) => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL + "/date-wise-by-status?fromDate=" + fromDate + "&toDate=" + toDate + "&status=" + status,
        }).then(({ data, success }) => {
            if (success) {
                const row = data.data;

                const dataObj = {
                    ...row,
                    addedEnquiries: mapEnquiryList(row.addedEnquiries),
                    allocatedVisitedEnquiries: mapEnquiryList(row.allocatedVisitedEnquiries),
                    allocatedUnvisitedEnquiries: mapEnquiryList(row.allocatedUnvisitedEnquiries),
                };
                dispatch(enquiryMasterSuccess({ row: dataObj }));
                return { response: dataObj, success };
            }
            return { response: {}, success };
        });
        return response;
    } catch (e) {
        return { response: {}, success: false };
    }
};


export const getAllStateOptimized = () =>
    async () => {
        try {
            const response = apiGet({
                url: URL + "/get-all-states",
            }).then(({ data, success }) => {
                if (success) {
                    return { response: data.data, success };
                }
                return { response: [], success };
            });
            return response;
        } catch (e) {
            return { response: [], success: false };

        }
    };